module.exports = __webpack_public_path__ + "static/Lora-BoldItalic-1ad2aded60e9b2fa80315e8aab0e0a5d.ttf";